import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import classes from "@/components/page-modules/pricing/styles/PlanItemSkeleton.module.scss";
import cn from "classnames";
const PlanItemSkeleton = () => {
  return <SkeletonTheme baseColor="#ecf1f1" highlightColor="#F1F2F3" data-sentry-element="SkeletonTheme" data-sentry-component="PlanItemSkeleton" data-sentry-source-file="PlanItemSkeleton.tsx">
      <div className={classes.plan_column}>
        <div className={classes.plan_column__item}>
          <div>
            <h3 className={classes.plan_name}>
              <Skeleton data-sentry-element="Skeleton" data-sentry-source-file="PlanItemSkeleton.tsx" />
            </h3>

            <p className={classes.plan_des}>
              <Skeleton count={3} data-sentry-element="Skeleton" data-sentry-source-file="PlanItemSkeleton.tsx" />
            </p>

            <div className={classes.price_box}>
              <div className={cn(classes.plan_price, classes.price_skeleton)}>
                <Skeleton height={48} containerClassName={classes.flex_1_container} data-sentry-element="Skeleton" data-sentry-source-file="PlanItemSkeleton.tsx" />
              </div>
            </div>

            <Skeleton height={48} data-sentry-element="Skeleton" data-sentry-source-file="PlanItemSkeleton.tsx" />

            <div className={classes.planDetails_box}>
              <div className={classes.details_row}>
                <Skeleton containerClassName={classes.flex_1_container} data-sentry-element="Skeleton" data-sentry-source-file="PlanItemSkeleton.tsx" />
              </div>
              <div className={classes.details_row}>
                <Skeleton containerClassName={classes.flex_1_container} data-sentry-element="Skeleton" data-sentry-source-file="PlanItemSkeleton.tsx" />
              </div>
              <div className={classes.details_row}>
                <Skeleton containerClassName={classes.flex_1_container} data-sentry-element="Skeleton" data-sentry-source-file="PlanItemSkeleton.tsx" />
              </div>
              <div className={classes.details_row}>
                <Skeleton containerClassName={classes.flex_1_container} data-sentry-element="Skeleton" data-sentry-source-file="PlanItemSkeleton.tsx" />
              </div>
              <div className={classes.details_row}>
                <Skeleton containerClassName={classes.flex_1_container} data-sentry-element="Skeleton" data-sentry-source-file="PlanItemSkeleton.tsx" />
              </div>
              <div className={classes.details_row}>
                <Skeleton containerClassName={classes.flex_1_container} data-sentry-element="Skeleton" data-sentry-source-file="PlanItemSkeleton.tsx" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </SkeletonTheme>;
};
export default PlanItemSkeleton;